import CoreService from "@/src/modules/core/services/core";

import {filesApi} from "../api";
import {FileCreateInput, FileCreateRequest} from "../types";

function normalizeCreateInput(input: FileCreateInput): FileCreateRequest {
  return Array.isArray(input) ? {files: input} : input;
}

class FilesService extends CoreService {
  async create(input: FileCreateInput) {
    const response = await filesApi.createFiles(normalizeCreateInput(input));
    return response.data.success === 1 ? response.data.data.files : [];
  }
}

export const filesService = new FilesService();
